var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass: "category-tabs",
      attrs: { role: "navigation", "aria-label": _vm.ariaLabel },
    },
    [
      _vm.showLeft
        ? _c(
            "button",
            {
              staticClass: "scroll-arrow left",
              attrs: { "aria-hidden": "true", tabindex: "-1" },
              on: {
                click: function ($event) {
                  return _vm.scrollLeft()
                },
              },
            },
            [_c("span", { staticClass: "icon-arrow-previous" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        {
          ref: "scrollContainer",
          staticClass: "nav",
          attrs: { "aria-label": _vm.ariaLabel },
        },
        _vm._l(_vm.tabs, function (tab, index) {
          return _c(
            "li",
            {
              key: index,
              class:
                tab.id === _vm.activeTabId ? "nav-item active" : "nav-item",
            },
            [
              tab.href
                ? _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        href: tab.href,
                        "aria-current": tab.id === _vm.activeTabId,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.clickHandler(tab.id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(tab.label) +
                          "\n            "
                      ),
                    ]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "nav-link",
                      attrs: { "aria-current": tab.id === _vm.activeTabId },
                      on: {
                        click: function ($event) {
                          return _vm.clickHandler(tab.id)
                        },
                      },
                    },
                    [
                      tab.iconName
                        ? _c("span", {
                            class: "item-icon " + tab.iconName,
                            attrs: { "aria-hidden": "true" },
                          })
                        : _vm._e(),
                      _vm._v(
                        "\n                " +
                          _vm._s(tab.label) +
                          "\n            "
                      ),
                    ]
                  ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.showRight
        ? _c(
            "button",
            {
              staticClass: "scroll-arrow right",
              attrs: { "aria-hidden": "true", tabindex: "-1" },
              on: {
                click: function ($event) {
                  return _vm.scrollRight()
                },
              },
            },
            [_c("span", { staticClass: "icon-arrow-next" })]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }